import React from 'react';
import './DialogueFlagSelector.css';

export type DialogueFlag = 'red' | 'yellow' | 'green' | null;

interface DialogueFlagSelectorProps {
  value: DialogueFlag;
  onChange: (flag: DialogueFlag) => void;
  disabled?: boolean;
  compact?: boolean;
}

const FLAGS: { value: DialogueFlag; label: string; className: string }[] = [
  { value: 'red', label: 'Red', className: 'flag-red' },
  { value: 'yellow', label: 'Yellow', className: 'flag-yellow' },
  { value: 'green', label: 'Green', className: 'flag-green' },
];

const DialogueFlagSelector: React.FC<DialogueFlagSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  compact = false,
}) => {
  const handleClick = (e: React.MouseEvent, flag: DialogueFlag) => {
    e.stopPropagation();
    if (disabled) return;
    onChange(value === flag ? null : flag);
  };

  return (
    <div
      className={`dialogue-flag-selector ${compact ? 'dialogue-flag-selector-compact' : ''}`}
      onClick={(e) => e.stopPropagation()}
      role="group"
      aria-label="Dialogue flag"
    >
      {FLAGS.map((flag) => (
        <button
          key={flag.value}
          type="button"
          className={`dialogue-flag-btn ${flag.className} ${value === flag.value ? 'is-active' : ''}`}
          title={value === flag.value ? `Clear ${flag.label} flag` : `Set ${flag.label} flag`}
          disabled={disabled}
          onClick={(e) => handleClick(e, flag.value)}
          aria-pressed={value === flag.value}
        />
      ))}
    </div>
  );
};

export default DialogueFlagSelector;
